import { AuthErrorCode, BusinessErrorCode, ListingMenuErrorCode } from '@pulsify/shared/errors'
import { NetworkError } from '@pulsify/shared/network-error'

export type ScanFailure =
  | 'no_credits'
  | 'unsupported_file'
  | 'file_too_large'
  | 'too_many_files'
  | 'unavailable'
  | 'busy'
  | 'failed'

const FAILURE_BY_CODE: Record<string, ScanFailure> = {
  [BusinessErrorCode.InsufficientCredits]: 'no_credits',
  [ListingMenuErrorCode.MenuFileUnsupported]: 'unsupported_file',
  [ListingMenuErrorCode.MenuFileTooLarge]: 'file_too_large',
  [ListingMenuErrorCode.TooManyMenuFiles]: 'too_many_files',
  [ListingMenuErrorCode.MenuScanUnavailable]: 'unavailable',
  [AuthErrorCode.RateLimited]: 'busy',
}

/** Which message a failed reading shows; whatever is not recognised reads as "could not be read". */
export function scanFailure(error: unknown): ScanFailure {
  if (!(error instanceof NetworkError)) return 'failed'
  const byCode = error.code ? FAILURE_BY_CODE[error.code] : undefined
  if (byCode) return byCode
  return error.statusCode === 413 ? 'file_too_large' : 'failed'
}
